var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-group" }, [
    _c("div", { staticClass: "input-group-prepend" }, [_vm._t("prepend")], 2),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.text,
          expression: "text"
        }
      ],
      staticClass: "form-control",
      attrs: { type: "text" },
      domProps: { value: _vm.text },
      on: {
        keyup: function($event) {
          if (
            !("button" in $event) &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          _vm.$emit("enter")
        },
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.text = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "input-group-append" }, [_vm._t("append")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d516942", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d516942","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/XInput.vue
// module id = 21
// module chunks = 1